export default {
  en: {
    default: {
      // Cookie consent (cookie-consent.vue), same texts as the landing site banner
      cookieMessage:
        'We use cookies for the proper functioning of this website and to improve your user experience. More information can be found at',
      cookiePrivacySettings: 'Privacy Settings',
      cookieRejectAll: 'REJECT ALL',
      cookieAdjustSettings: 'ADJUST SETTINGS',
      cookieAcceptAll: 'ACCEPT ALL',
      cookieRejectOptional: 'REJECT OPTIONAL',
      cookieSaveSelection: 'SAVE SELECTION',
      cookieSettings: 'Cookie settings',
      cookies: 'Cookies',
      cookieAlwaysIncluded: 'always included',
      necessaryCookies: 'Necessary cookies',
      necessaryCookiesMessage:
        'Necessary cookies are those that the Portal needs in order for it to fully and functionally perform all procedures for Event displaying and Tickets purchasing. This type of cookie cannot be disabled independently.',
      analyticsCookies: 'Analytics cookies',
      analyticsCookiesMessage:
        'Help us track visits and how the Portal is used (Google Analytics) so that we can improve it. They are only enabled with your consent.',
      marketingCookies: 'Marketing cookies',
      marketingCookiesMessage:
        'Used by CoreEvent and, on the pages of individual events, by the organizers of those events (via Meta Pixel and Google Ads) to measure ad performance and show ads for events on other platforms, such as Facebook and Instagram. Data may be transferred to advertising service providers, including transfers to the USA. They are only enabled with your consent.',
      invitePageLinkDescription:
        'The provided link allows users to directly access the ticket purchase page.',
      invitePageQrCodeDescription:
        'Download the QR code that leads to ticket purchase and place it on your poster.',
      createEmail: 'Create e-mail',
      //LoginContainer
      loginHeader: 'Hey, welcome back!',
      forgotPasswordLogin: 'Forgot password?',
      logIn: 'Log in',
      loginFormEmail: 'Email*',
      wrongTicketQuantity:
        'The selected number of tickets is no longer available. Please reduce the quantity and try again.',
      categoryTicketRequirement_one:
        'For each package, select one ticket from every category. Every category must have the same number of tickets. Maximum packages per order: {{maxPackages}}.',
      categoryTicketRequirement_other:
        'For each package, select {{count}} tickets from every category. Every category must have the same number of tickets. Maximum packages per order: {{maxPackages}}.',
      selectCategoryTicketPackage:
        'Select tickets from every category to put together at least one package.',
      maxCategoryTicketPackages:
        'You exceeded the package limit ({{maxPackages}}). Remove extra tickets to continue.',
      missingCategoryPackageTickets_one:
        'Add one more ticket to a category with fewer selected tickets.',
      missingCategoryPackageTickets_other:
        'Add {{count}} more tickets to the categories with fewer selected tickets.',
      loginFormPassword: 'Password*',
      //RecoverPassowrdContainer
      forgotPasswordPageHeader: 'Forgot password',
      changePassword: 'Change Password',
      //Password field labels & errors
      newPassword: 'New Password',
      repeatPassword: 'Repeat password',
      confirmPassword: 'Confirm password',
      passwordLengthErrorMessage: 'Password must contain 5 characters at least',
      passwordsDoNotMatchError: 'Passwords don`t match',
      orderDiscount: 'Promo code discount:',
      giftCardDiscount: 'Gift card amount:',
      promoCodeDiscount: 'Promo code discount:',
      cinehillPackageOneTicketRemaining:
        'You can redeem up to one more ticket with this promo code.',
      cinehillPackageTicketsRemaining:
        'You can redeem up to {{count}} more tickets with this promo code.',
      cinehillPackageNoTicketsRemaining:
        'All tickets from this promo code have already been redeemed.',
      sendRequest: 'Send request',
      membershipRequest: 'Membership request',
      chooseMembershipType: 'Choose membership type',
      membershipRequestDescription: 'Send a request to become a member of the organization.',
      membershipRequestButton: 'Send request',
      membershipRequestSuccess: 'Membership request sent successfully',
      membershipRequestError: 'Membership request failed',
      membershipRequestErrorDescription: 'Unfortunately, an error occurred. Please try again.',
      membershipRequestErrorButton: 'Try again',
      membershipRequestStatus: 'Membership request status',
      membershipRequestStatusPending: 'Pending',
      membershipRequestStatusApproved: 'Approved',
      membershipRequestStatusRejected: 'Rejected',
      curatedInvitationResponse: 'Your response has been successfully saved',
      //RegisterContainer
      whatIsCoreEventFee: 'What is CoreEvent fee?',
      required: 'This field is required',
      date: 'This field must be date',
      between: 'This field is out of range',
      minLength: 'This field should contain more values',
      maxLength: 'This field should contain less values',
      minDate: 'This field should be after',
      maxDate: 'This field should be before',
      EmailError: 'This field must be an email',
      httpUrl: 'This field must be http or https url',
      minValue: 'Provided value is too small',
      maxValue: 'Provided value is too big',
      sameAs: 'This field must be the same as some other field',
      notIn: 'Provided value is already taken',
      numeric: 'This field must be a number',
      url: 'This field must a valid url',
      coreEventFeeInvoice: 'CoreEvent ticketing fee',
      coreEventFee: 'CoreEvent fee',
      function: 'Function',
      companyOrganization: 'Name of the company / organization',
      coreEventFeeDescription:
        'The CoreEvent fee covers the cost of selling tickets quickly and securely. The fee, applied to each purchased ticket, includes the costs of support, maintenance of the server system and administrative work. The amount of the fee may vary according to the commercial agreement with the Event Organizer and is non-refundable.',
      registration: 'Registration',
      registerPaymentVerification: 'Purchase and payment verification',
      onlinePaymentWspay: 'Online payment through the WS Pay system',
      onlinePaymentProvider: 'Online payment through {{provider}}',
      paymentMethodsLoading: 'Loading payment methods…',
      paymentMethodsUnavailable: 'No payment methods are currently available.',
      paymentMethodsError: 'Unable to load payment methods. Please reload and try again.',
      paymentCheckoutError: 'Payment could not be started. Please try again.',
      onlinePaymentCorvus: 'Online payment through the Corvus Pay system',
      choosePaymentMethod: 'Choose a payment method',
      cardPayment: 'Card payment',
      revolutPaymentTitle: 'Pay by Card, Revolut Pay, and more',
      revolutPaymentDescription: 'Secure payments via Revolut',
      buyATicket: 'Buy a ticket',
      cryptoPayment: 'Crypto payment',
      giftCardPayment: 'Gift card',
      giftCardPaymentDescription: 'Gift card payment',
      kiPayment: 'Kulturna iskaznica',
      kiPaymentDescription: 'Payment with Kulturna iskaznica',
      kiPartialPaymentTitle: 'Partial payment with Kulturna iskaznica',
      kiPartialPaymentDescription:
        'Kulturna iskaznica approved a partial amount. The remaining amount will be charged by card.',
      kiTotalOrderAmount: 'Total order amount',
      kiApprovedAmount: 'Approved by Kulturna iskaznica',
      kiCardPaymentAmount: 'Amount to pay by card',
      kiContinueToCardPayment: 'Continue to card payment',
      kiCancelPurchase: 'Cancel purchase',
      kiPaymentDetailsError: 'Unable to load payment details.',
      kiCancelPaymentError: 'Cancelling the transaction failed. Please try again.',
      giftCardDataTitle: 'Gift card data',
      giftCardCode: 'Gift card code*',
      giftCardAmount: 'Amount (EUR)*',
      giftCardDescription:
        'Enter the card number and the amount you want to spend in this order. In the next step, you will complete the payment if you chose one of the other forms.',
      giftCardAvailability: 'available',
      accountLogin: 'Log in with a user account',
      finishPaymentInNextStep: 'You will finish the payment on the next step',
      emailLogin: 'Login by e-mail',
      googleLogin: 'Google Sign in',
      facebookLogin: 'Facebook Sign in',
      registerIfNoAccount: 'Don`t have an account? Register ',
      here: 'here',
      register: 'Register',
      downloadTickets: 'Download tickets',
      signInToContinue: 'Sign in to continue with your purchase',
      remainingSeats: 'Remaining seats:',
      termsOfUse: 'terms of use',
      and: 'and',
      conditionsOfSale: 'conditions of sale',
      guest: 'Continue as guest',
      acceptCoreEvent: 'I accept CoreEvent',
      loginDescription:
        'Log in with your user account and keep tickets for all events in one place or just continue as a guest. You can create an account below.',
      registrationFinish: 'Thank you for registering!',
      submitNote: 'Thank you!',
      yourTicketTo: 'Your ticket to',
      registrationDescription:
        'The information you provided has been sent to the organizers. We will send an email to you as soon as possible.',
      addAttendee: 'Add another attendee',
      aplicationsClosed: 'Applications are closed',
      aplicationSuccessful: 'You have successfully registered a person.',
      tsLoginPrompt: 'Sign in to continue with your purchase',
      tsLoginEmail: 'Log in with email',
      tsRegister: 'Register',
      tsSelectSubscriptionStep: '1. Select a Subscription',
      tsSelectSeatStep: '2. Select Your Seat',
      tsSeatInCart: 'In cart',
      tsSubscribers: 'Subscribers',
      tsEditSubscriber: 'Edit',
      tsSeatNotSelected: 'No seat selected',
      tsChangeSeat: 'Change',
      tsRow: 'Row',
      tsSeat: 'Seat',

      tsSubscriber: 'Subscriber',
      tsFirstName: 'First name',
      tsLastName: 'Last name',
      tsEmail: 'Email',
      tsPhone: 'Phone',
      tsAddSubscriber: 'Add another subscriber',
      tsRemoveSubscriber: 'Remove',
      tsChooseSubscriberSeat: 'Choose seat',
      tsOrderAlreadyReserved: 'The order is already reserved. Retry payment preparation to keep your reserved seats.',

      tsPriceLabel: 'Price:',
      tsValidFromTo: 'Valid from {{from}} to {{to}}',
      tsAlreadyOwned: 'Already Owned',
      tsSoldOut: 'Sold out',
      tsAdmissionSeated: 'Seated',
      tsAdmissionGeneral: 'General admission',
      tsLoadingFloorPlan: 'Loading Floor Plan...',
      tsPurchaseTitle: 'Theater Subscription Purchase',
      tsKinoHrPurchaseTitle: 'Film Subscription Purchase',
      tsSubscriptionLabel: 'Theater Subscription',
      tsErrorLoadSubscriptions: 'Failed to load subscriptions.',
      tsErrorLoadFloorPlan: 'Failed to load floor plan for this subscription.',
      tsErrorLoginRequired: 'Please log in to continue.',
      tsErrorReservationFailed:
        'Reservation failed - please check if you already have an active subscription or if the selected seat is available',
      tsErrorReserveGeneric: 'An error occurred while reserving your subscription.',
      tsErrorInvalidEmail: 'Please enter a valid email before continuing.',
      tsErrorNameRequired: 'Please enter your first and last name.',
      tsErrorSeatRequired: 'Please select at least one seat before continuing.',
      tsErrorPurchaseGeneric: 'An error occurred during purchase.',
      tsGoogleLoginNotSuccessful: 'Google login was not successful. Please try again.',
      tsGoogleLoginFailed: 'Google login failed. Please try again.',
      tsOpisLabel: 'Description',
      tsCartTitle: 'Subscription Cart',
      tsCartEmpty: 'No subscription selected',
      tsCartEmptyHint: 'Select a subscription from the list to continue',
      tsCartValidLabel: 'Valid:',
      tsCartVenueLabel: 'Venue:',
      tsCartPromoLabel: 'Enter promo code (optional)',
      tsCartPriceLabel: 'Subscription Price:',
      tsCartSeatLabel: 'Seat:',
      tsCartTotalLabel: 'Total:',
      tsCartContinue: 'Continue to Checkout',
      tsCartLoginRequired: 'Please log in to continue',
      tsCartComplete: 'Complete Purchase',
      tsCartNoteLabel: 'Note:',
      tsCartNoteLine1:
        'This subscription includes access to all events within the validity period.',
      tsCartNoteLine2: 'You will receive a QR code that grants access to all performances.',
      tsFloorPlanUnavailable: 'Floor plan is not available for this subscription.',
      tsSelectSeatTitle: 'Select Your Seat',
      tsSeatAvailable: 'Available',
      tsSeatSold: 'Sold',
      tsSeatSelected: 'Selected',
      //Card-header
      hostedBy: 'Hosted by ',
      at: ' at ',
      //Attendee-data
      attendeeDataDescription:
        'Here you can provide information that will be used to create your accreditation at the event.',
      continueToWorkshops: 'Continue to workshops',
      send: 'Send',
      back: 'Back',
      //Ediit-attendee-data
      editSuccess: 'Registration of your data was successful.',
      //UserProfileContainer
      //UserProfileLabels
      //SignUpContainer
      accountSettings: 'Account settings',
      firstName: 'First name',
      countryOptional: 'Country',
      lastName: 'Last name',
      email: 'Email',
      confirmEmail: 'Confirm email',
      password: 'Password',
      save: 'Save',
      understand: 'I understand',
      continue: 'continue',
      signupHeader: 'Start Your Free Trial.',
      //Orders
      paymentUnsuccessful: 'Payment unsuccessful!',
      paymentUnsuccessfulDescription:
        'An error occurred during purchase. Please try again or choose another payment method.',
      paymentUnsuccessfulActionButton: 'Back to payment',
      cancel: 'Cancel',
      //Canceled payment
      paymentDone: 'The payment has already been made',
      paymentCanceled: 'Payment cancelled, you will be redirected back to the registration form',
      //Footer
      termsOfService: 'Terms of service',
      confirmOrder: 'Confirm order',
      termsOfSale: 'Terms of sale',
      youAreNot: 'You are not',
      clickHere: 'Click here',
      ticketPersonalizationCheckoutDescription:
        'Enter the buyer information. Then fill in the visitor fields.',
      ticketOwnerDetails: 'Ticket owner details',
      ticketOwnerDetailsDescription: 'Required fields are marked with an asterisk.',
      ticketOwnerSameAsBuyer: 'The owner’s information is the same as the buyer’s information',
      ticketOwnerSendTicketToOwner: 'Send the ticket to the owner’s email as well',
      ticketOwnerFirstNameRequired: 'Owner first name is required.',
      ticketOwnerLastNameRequired: 'Owner last name is required.',
      ticketOwnerEmailRequired: 'Owner email is required.',
      ticketOwnerValidationError: 'Please enter owner details for each ticket.',
      ticketOwnerTitleWithName: 'Ticket {{ticketName}} #{{ticketNumber}}',
      ticketOwnerTitle: 'Ticket #{{ticketNumber}}',
      customerDataDescription: 'All fields marked with an asterisk are required.',
      subscription1: 'I agree to share my email address with the organizer',
      quickRegisterDescription:
        'Create a password for your new CoreEvent account and enjoy the benefits of faster ticket purchases and easy access to all purchased tickets. We will use the one listed above to create the account email address.',
      address: 'Address',
      quickRegister: 'Create an account quickly and easily.',
      subscription2:
        'for the purpose of receiving notifications about the latest events, offers or any important information related to the events of the mentioned organizer.',
      privacyPolicy: 'Privacy Policy',
      personalDataProtection: 'Protection of personal data',
      //Input Error messages
      yourAccount: 'Your user account',
      cart: 'Cart',
      customerData: 'Customer information',
      ownerData: 'Owner information',
      submitNoteDescription: 'The information you provided has been sent to the organizers.',
      addPromoCode: 'Add promo code',
      inTotal: 'In total',
      remainingTime: 'Remaining time',
      continueShopping: 'Continue shopping',
      singedInAs: 'You are signed in as:',
      viewTheOrder: 'View the order',
      requiredErrorMessage: 'This field is required',
      loginModalDescription: 'Login with your email and password',
      newRequest: 'New request',
      tryAgain: 'Try again',
      error: 'Error',
      noPasswordQuestion: 'Don`t have a password?',
      oneTimePasswordLogin: 'Login with one-time password',
      noAccountQuestion: 'Don`t have an account?',
      loginHere: 'Login here',
      otpLoginTitle: 'Login with one-time password',
      otpLoginDescription:
        'Enter your email address to receive a one-time password. The password will be sent to your email address and can be used to log in to your account.',
      enterEmail: 'Enter email',
      sendOneTimePassword: 'Send one-time password',
      backToPasswordLogin: 'Back to password login',
      signUpHere: 'Sign up here',
      purchasedIn: 'The ticket was purchased in',
      invoiceNumber: 'Invoice number',
      invoicePendingTitle: 'Your invoice is being prepared',
      invoicePendingDescription: 'This page will update automatically when your invoice is ready.',
      invoiceLoadError: 'Unable to load your invoice. Please try again.',
      invoiceRetry: 'Check again',
      invoiceDate: 'Invoice date',
      notLoggedIn: 'You are not logged in',
      eventDate: 'Event date',
      invoiceIssued: 'Invoice issued',
      getMyTicket: 'Get my tickets',
      order: 'Order',
      paymentDeadline: 'Payment deadline',
      customer: 'Customer',
      inoviceNum: 'Invo. num.',
      unit: 'unit',
      productDescription: 'Product/service description',
      ticketDescription:
        'By purchasing this ticket, the visitor fully accepts all the conditions and rules of conduct of the event venue and organizer, as well as the conditions stated on this ticket. By not complying with the stated conditions and rules, the visitor will be prohibited from entering the event or will be removed from the venue. Once purchased, the ticket cannot be exchanged or refunded except in case of cancellation or change of event date. CoreEvent is not responsible in case of damage, loss or theft of the ticket or its protective data (such as barcode, serial number, security code, etc.) and in these and similar cases no refund or replacement of the ticket is possible. Damaged, stolen, a ticket that is forged and does not have a steak or security information is invalid and the visitor will not be able to enter the event with such a ticket. Buy tickets exclusively at authorised points of sale! After reading the unique code on the ticket, the ticket becomes invalid, and entry is allowed only to the first bearer of that ticket. Any subsequent login attempt with the same code will be disabled. CoreEvent d.o.o. is an intermediary in the sale of tickets and does not organize the events for which it sells tickets, and as such is not responsible for refunds or changes in the event program. If the event is canceled or the date is changed, the refund will be possible only at the point of sale where the ticket was purchased, within one month of the scheduled start of the event. In certain cases, the refund will be provided directly by the organizer, about which customers will be informed in time. You can get more information at www.core-event.co and at the e-mail address support@core-event.co. Any counterfeiting, abuse and illegal resale of CoreEvent tickets is punishable by law and will be reported to the police. It is forbidden to bring weapons, pyrotechnics, bottles, cans and other items that could endanger safety, as well as audio-visual recording equipment, to the shooting site. Loud music can damage your hearing. By coming to the event, the visitor fully assumes all risks such as the risk of loss, theft and damage to their own property and the risk of bodily injury. By coming to the event, the visitor agrees to be audio-visually recorded without restrictions and without the possibility of financial compensation for the use of said recordings.',
      backToEventPage: 'Back to the event page',
      backToZkm: 'Back to',

      //404
      '404': 'Page not found',
      released: 'Released',
      retailCustomer: 'Retail Customer',
      amout: 'amount',
      event: 'Event:',
      pieces: 'pieces',
      base: 'base',
      totalNoTax: 'Total without tax',
      viewAllEvents: 'View all events',
      ticketSoldOut: 'Tickets are sold out.',
      ticketSoldOutDescription: 'Unfortunately, all tickets for this event are sold out.',
      eventFull: 'Event full',
      eventFullDescription:
        'All spots for this event have been filled. If additional availability opens up, please contact the organizer.',
      backToEvents: 'Back to events',
      buyATicketZkm: 'Buy a ticket',
      ticketCategoryZkm: 'Ticket category',
      tax: 'tax',
      itemAmount: 'item amount',
      price: 'price',
      issuedInTheName: 'Issued in the name and on behalf of the organizer',
      useTerm: 'Terms of use',
      coreEventTeam: 'Your CoreEvent team wishes you a pleasant time!',
      paymentSuccessful: 'Payment successful',
      paymentMethod: 'Method of payment',
      ticketReady:
        'Your ticket has been purchased and is in your profile, and will soon be delivered to your email address. We wish you a pleasant time!',
      subscriptionReady:
        'Your subscription has been purchased successfully and is now active in your profile. You will receive confirmation details via email shortly. Welcome to the season!',
      operator: 'Operator / Invoice issued',
      notes: 'Notes',
      gdprText: 'Rules for the protection of personal data on the Internet - COREEVENT.',
      contacts: 'Contacts',
      cityOptional: 'City',
      vat: 'VAT',
      marketingConsent:
        'I give my consent to CoreEvent d.o.o. processes my personal data in the above form in accordance with the purpose and intention of the Organizer of the Event for which I purchase the Ticket via Portal`s email address for its marketing purposes and gives its consent for the stated purpose can deny at any time, all in accordance with the General Data Protection Regulation and',
      marketingConsentEuropeanGymnastics:
        'I give my consent to CoreEvent d.o.o. to process my personal data in the above form in accordance with the purpose and intention of the Organizer of the Event for which I purchase the Ticket via the Portal, and on behalf of and for the account of European Gymnastics, acting as co-organizer and/or the competent sports governing body, and to process the provided email address for its marketing purposes. I understand that I may withdraw my consent for the stated purpose at any time, all in accordance with the General Data Protection Regulation and the Rules for the protection of personal data on the Internet - COREEVENT.',

      contractForCustomers: 'General conditions of the contract for customers',
      companyRegistered:
        'The company is registered in the court register of the Commercial Court in Zagreb under number 081377997. The basic capital of the company amounts to 2.800,00 EUR and has been paid in full. Account for regular the company`s business is managed by Privredna banka Zagreb',
      organizerMessage: 'Organizer message',
      organizer: 'Organizer',
      ourAddresses: 'Our addresses',
      exchangeRate: 'Converted at a fixed conversion rate of 1 EUR = 7.53450 HRK',
      organizerSeller: 'Organizer (seller)',
      ticketUnavailable: 'Tickets are currently not available',
      ticketUnavailableDescription:
        'For information about ticket availability, please contact the event organizer.',
      eventCanceled: 'Event canceled',
      eventCanceledDescription:
        'For tickets purchased through the webshop, you will receive an automatic refund.',
      bulledInName:
        'This item is billed in the name and for the account of the event organizer (seller)',
      requiredSeatError:
        'Please select neighboring locations. It is not allowed to leave it blank.',
      seatMaxLimitReached: 'Maximum number of tickets for this ticket type has been reached.',
      bundleOfferChooseMore: 'Choose',
      bundleOfferChooseMoreGratisCount: '{{count}} free',
      bundleOfferChooseMoreGratis: 'Choose {{count}} more free ticket(s).',
      bundleOfferGratisAdded: 'You got {{count}} free ticket(s).',
      bundleOfferFixExcessGratis:
        'Choose {{count}} more ticket(s) to reactivate the free ticket, or remove the free seat.',
      yourTicketLocation:
        'You can find your ticket at the bottom of this page. You can print the ticket or or show the ticket via mobile phone at the entrance',
      ticketQuantityError:
        'The amount of tickets made is less than the number of places it connects to! Please increase the amount of the selected ticket or choose a smaller amount of seats.',
      ticketCategory: 'Ticket categories',
      seatSelection: 'Seat selection',
      chooseTickets: 'Choose tickets via the hall plan',
      available: 'Available',
      unavailable: 'Unavailable',
      unavailableSeat: 'Unavailable seat',
      selected: 'Selected',
      selectedSeat: 'Selected seat',
      unselectedSector: 'Unselected sector',
      linkLocationWithUserProfileCheckbox: 'Use this location automatically for future purchases',
      finishOrder: 'FINISH ORDER',
      keksPayDesc: 'The fastest and without fees via the KEKS Pay application!',
      ticketTypeRegular: 'Type',
      ticketType: 'Ticket type',
      subscriptionType: 'Subscription type',
      ticketQuantity: 'Quantity',
      editShoppingCart: 'edit',
      continueShoppingCart: 'Continue shopping',
      confirmShoppingCart: 'Confirm',
      regularSignIn: 'You are not logged in',
      insertPromoCode: 'Enter promo code (optional)',
      subtotalPriceLabel: 'Subtotal:',

      receiptInfo: 'Receipt information',
      privateReceipt: 'Private receipt',
      r1Invoice: 'Company receipt (R1 invoice)',
      legalEntityName: 'Legal entity name*',
      legalEntityVatNumber: 'VAT number*',
      legalEntityVatNumberFormatInvalid:
        'Enter the VAT number as one sequence, for example 123456789 (without spaces, dots, or hyphens).',
      legalEntityVatNumberInvalid:
        'Enter a valid VAT number for the selected country, without the country code.',
      addressLabel: 'Address (street and number)*',
      zipCode: 'ZIP code*',
      city: 'City*',
      country: 'Country*',
      chooseMinimum: 'Choose minimum',
      tickets1: 'tickets',
      tickets2: 'tickets',
      loginToContinue: 'Sign in to continue with your purchase.',
      promoCodeDescriptionTitle: 'What is promo code?',
      becomeMemberTitle: 'Become a member',
      becomeMemberDescription:
        'Members enjoy exclusive access to discounted tickets and special benefits.',
      usedAllMemberships: 'Membership ticket limit reached',
      usedAllMembershipsDescription:
        'The membership discount is limited to one ticket per member per screening. You have already used the membership ticket allowed for this screening.',
      becomeMemberButtonText: 'Join now',
      usedAllMembershipsButtonText: 'Okay',
      membershipTicketAvailable: 'Membership has been applied.',
      membershipTicketUnavailable:
        'Your membership is active, but there are no available member tickets for this event.',
      promoCodeDescriptionPart1:
        'Sellers can give customers a promo code to enter at checkout to get a discount on their purchase. Entering the promo code is optional.',
      promoCodeDescriptionPart2: 'Here you can enter:',
      promoCodeDescriptionPart3: 'Promo code for discount on purchase',
      promoCodeDescriptionPart4: 'Membership card number or subscription number for theaters',
      activate: 'activate',
      requiredFieldsDescription: 'Fields marked with an asterisk are required.',
      annualTicket: 'Annual ticket',
      postalCode: 'Postal code',
      disableSportMembershipTicket: 'For members',
      membership: 'Membership',
      eventPasswordRequired: 'Password required',
      eventPasswordSaleUnavailableTitle: 'Tickets are not on sale yet',
      eventPasswordSaleUnavailableDescription:
        'Password-protected ticket sales are currently unavailable. Please follow the organizer’s announcements for updates on when sales will open.',
      eventPasswordDescription:
        'Presale is currently open with a password only. Tickets will be available for official sale soon.',
      passwordLabel: 'Password',
      backToEvent: 'Back to Event',
      openInExternalBrowser: 'To sign in with Google, please ',
      openInExternalBrowserBold: 'allow this link to open in your default browser.',
      openInBrowser: 'Open in browser',
      loginWithEmail: 'Log in with email',
      continueHere: 'Continue here',
      checkOnTicketSwap: 'check availability on TicketSwap',
      checkOnTicketSwapShort: 'check on TicketSwap',
      bannerText:
        'Dear customers, due to technical difficulties in the WSPay system, payments through the CoreEvent website are temporarily unavailable. Our partner is working on resolving the issue as quickly as possible, and payments should be available again soon. Thank you for your understanding!',
      ticketsReserved: 'Tickets reserved successfully!',
      ticketsReservedDescription: {
        part1: 'Your tickets have been reserved, and after processing the transaction',
        part2: 'tickets and invoice will be sent to your email',
        part3:
          'It is possible that the bank will reject the transaction, and you will be notified by email. If the demand is high, processing may take longer. Thank you for your patience!',
      },
      ticketsFailedPayment: 'Tickets payment failed!',
      ticketsFailedPaymentDescription: {
        part1:
          'Unfortunately, your transaction has not been successfully processed and the bank has rejected the payment. Therefore,',
        part2: ' tickets are no longer reserved.',
        part3: ' Please select the desired tickets and complete the purchase with a new payment.',
      },
      repeatPurchase: 'Repeat purchase',
      subscriptionCheckoutInterrupted: 'You left the payment page',
      subscriptionCheckoutInterruptedDescription: 'Payment has not been confirmed and your subscription is not active. We are checking the final payment status.',
      subscriptionPaymentChecking: 'Checking your payment',
      subscriptionPaymentCheckingDescription: 'Your subscription will become active after payment is confirmed.',
      subscriptionPaymentPendingAdvice: 'Places remain temporarily reserved while payment is unconfirmed. Please check this order before starting another payment. Confirmation and your receipt are sent only after a successful purchase.',
      subscriptionPaymentUnconfirmed: 'Payment not yet confirmed',
      subscriptionPaymentCheckingStatus: 'Checking payment status.',
      subscriptionPaymentCanceled: 'Payment canceled',
      subscriptionPaymentNotCompleted: 'Payment was not completed',
      subscriptionPaymentNotCompletedDescription: 'This payment did not complete a subscription purchase. You can return to the subscriptions page.',
      subscriptionReserved: 'Subscription reserved successfully!',
      subscriptionReservedDescription: {
        part1: 'Your subscription has been reserved, and after processing the transaction',
        part2: 'subscription confirmation and receipt will be sent to your email',
        part3:
          'It is possible that the bank will reject the transaction, and you will be notified by email. If the demand is high, processing may take longer. Thank you for your patience!',
      },
      subscriptionFailedPayment: 'Subscription payment failed!',
      subscriptionFailedPaymentDescription: {
        part1:
          'Unfortunately, your transaction has not been successfully processed and the bank has rejected the payment. Therefore,',
        part2: ' your subscription is no longer reserved.',
        part3: ' Please try to complete the purchase again with a new payment.',
      },
      repeatSubscriptionPurchase: 'Retry subscription purchase',
      ticketsSuccessfulPayment: 'Tickets successful payment',
      ticketsSuccessfulPaymentDescription: {
        part1: 'Your purchase has been successfully completed!',
        part2:
          ' Tickets and invoice will be sent to your email address in the shortest possible time.',
        part3: 'Thank you for your trust and we wish you a pleasant experience at the event!',
      },
      transactionStatuses: {
        PENDING: 'Transaction in progress',
        SUCCESSFUL: 'Transaction successful',
        FAILED: 'Transaction failed',
      },
      transactionStatusesDescription: {
        PENDING: 'Please wait.',
        SUCCESSFUL: '',
        FAILED: 'Try again.',
      },
      protectTicketPurchase: 'Protect your ticket purchase',
      addTicketInsuranceRecommended: 'Add ticket insurance (recommended)',
      noTicketInsurance: 'I do not want ticket insurance',
      noSurcharge: 'No surcharge',
      insuranceTerms: 'insurance terms',
      ticketInsuranceDescriptionPart1: 'By adding ticket insurance, you gain the right to a ',
      ticketInsuranceDescriptionHighlighted: 'refund of your purchase amount',
      ticketInsuranceDescriptionPart2:
        ' if you cannot attend the event due to justified and documented reasons. Covered reasons and refund conditions are listed in the ',
      ticketInsuranceDescriptionPart3:
        '. The insurance price is added to the total order amount, and you will receive insurance confirmation by email after purchase.',
      insuranceReasonHealth: 'Health reasons',
      insuranceReasonHealthSub: '(including child illness)',
      insuranceReasonAccidents: 'Accidents and injuries',
      insuranceReasonTraffic: 'Traffic accidents',
      insuranceReasonPublicTransport: 'Public transport delays',
      insuranceReasonEmergency: 'Emergency situations',
      insuranceReasonEmergencySub: '(e.g. fire, flood or burglary)',
      insuranceReasonOther: 'Other urgent cases',
      insuranceReasonOtherSub: '(in accordance with insurance terms)',
      insuranceConfirmationPart1: 'I confirm that I am familiar with ',
      insuranceConfirmationPart2: ' and that I accept them.',
      insuranceSelectionRequired: 'Please select one of the options.',
      insuranceTermsRequired: 'You need to accept the insurance terms.',
      ticketInsurance: 'Ticket insurance',
      ticketTypes: 'Ticket types',
      selectLocation: 'Select location',
      chooseTicketCategory: 'Choose ticket category',
      chooseFloorPlanTicket: 'Choose a ticket',
      allFloorPlanTicketTypes: 'All ticket types',
      floorPlanZoomIn: 'Zoom in',
      floorPlanZoomOut: 'Zoom out',
      floorPlanResetView: 'Reset view',
      readMore: 'READ MORE',
      readLess: 'READ LESS',
      details: 'Details',
      section: 'Section',
      row: 'Row',
      seat: 'Seat',
      tableNumber: 'Table number',
      capacity: 'Capacity',
      floorPlanHelperRange: 'Choose {{min}}-{{max}} tickets',
      floorPlanHelperMaxOnly: 'Max. {{max}} tickets',
      sharedTableChoosePackage: 'Choose one of the available table packages.',
      sharedTableNoAvailablePackages: 'There are currently no available packages for this table.',
      sharedTableTicketSingular: 'ticket',
      sharedTableTicketPlural: 'tickets',
      add: 'Add',
      close: 'Close',
      addedToCart: 'Added to cart',
      accessibleTicketInfo:
        'If you need additional accommodation or more flexibility, feel free to contact the organizer directly by phone or e-mail to make a reservation.',
      escortQuestion: 'Will you have an escort (a person accompanying you)?',
      escortYes: 'Yes',
      escortNo: 'No',
      disabilityCardNumber: 'Disability card number',
      disabilityCardNumberRequired:
        'Please enter the disability card number for each accessible ticket.',
      insuranceWithdrawal: {
        pageTitle: 'Withdrawal from ticket insurance',
        explanation:
          'You have the right to withdraw from the ticket insurance within 14 days of concluding the insurance contract, or of receiving the insurance confirmation, without giving any reason. Withdrawing from the insurance does not affect your ticket, which stays valid.',
        loading: 'Loading order details…',
        eventLabel: 'Event',
        purchaseDateLabel: 'Purchase date',
        insuredAmountLabel: 'Insured amount',
        invoiceNumberLabel: 'Invoice number',
        invoiceNumberHint: 'Invoice number as shown on the receipt, e.g. 118494-1-12',
        invoiceNumberRequired: 'Please enter the invoice number.',
        emailLabel: 'Email',
        emailRequired: 'Please enter the email used at purchase.',
        emailInvalid: 'Please enter a valid email address.',
        messageLabel: 'Message (optional)',
        confirmationLabel: 'I confirm that I want to withdraw from the ticket insurance for this order.',
        confirmationRequired: 'Please confirm the withdrawal to continue.',
        submit: 'Submit withdrawal',
        submitting: 'Submitting…',
        alreadyReceivedTitle: 'Withdrawal already received',
        alreadyReceivedDescription: 'We already received a withdrawal notice for this order on {{receivedAt}}.',
        successTitle: 'Withdrawal notice received',
        successDescription:
          'We received your withdrawal notice on {{receivedAt}}. Your reference is {{reference}}. The ticket itself stays valid.',
        notFoundTitle: 'Order not found',
        notFoundDescription:
          'We could not find an order matching those details, or it does not have ticket insurance. Please check the invoice number and email and try again.',
        throttledTitle: 'Too many attempts',
        throttledDescription: 'Please wait a while and try again.',
        networkErrorTitle: 'Something went wrong',
        networkErrorDescription: 'We could not reach the server. Please check your connection and try again.',
        tryAgain: 'Try again',
      },
    },
  },
  hr: {
    default: {
      // Cookie consent (cookie-consent.vue), same texts as the landing site banner
      cookieMessage:
        'Koristimo kolačiće za ispravno funkcioniranje ove web-stranice i poboljšanje vašeg korisničkog iskustva. Više informacija možete pronaći na',
      cookiePrivacySettings: 'Postavke privatnosti',
      cookieRejectAll: 'ODBIJ SVE',
      cookieAdjustSettings: 'PRILAGODI POSTAVKE',
      cookieAcceptAll: 'PRIHVATI SVE',
      cookieRejectOptional: 'ODBIJ OPCIONALNE',
      cookieSaveSelection: 'SPREMI ODABIR',
      cookieSettings: 'Postavke kolačića',
      cookies: 'Kolačići',
      cookieAlwaysIncluded: 'uvijek uključeni',
      necessaryCookies: 'Neophodni kolačići',
      necessaryCookiesMessage:
        'Neophodni kolačići su oni koji su Portalu potrebni kako bi isti potpuno i funkcionalno obavljao sve postupke za prikazivanje ponude Događaja te obavljanje kupnje Ulaznica te se taj tip kolačića ne može samostalno onemogućiti.',
      analyticsCookies: 'Analitički kolačići',
      analyticsCookiesMessage:
        'Pomažu nam pratiti posjećenost i način korištenja Portala (Google Analytics) kako bismo ga mogli unaprjeđivati. Uključuju se samo uz Vašu privolu.',
      marketingCookies: 'Marketinški kolačići',
      marketingCookiesMessage:
        'Koriste ih CoreEvent i, na stranicama pojedinih događaja, organizatori tih događaja (putem Meta Pixela i Google Adsa) za mjerenje uspješnosti oglasa i prikazivanje oglasa za događaje na drugim platformama, poput Facebooka i Instagrama. Podaci se mogu prenositi pružateljima oglasnih usluga, uključujući prijenos u SAD. Uključuju se samo uz Vašu privolu.',
      becomeMemberTitle: 'Postanite član',
      becomeMemberDescription:
        'Članovi ostvaruju ekskluzivno pravo na jeftinije ulaznice i posebne pogodnosti.',
      usedAllMemberships: 'Dosegnuli ste ograničenje članskih ulaznica',
      usedAllMembershipsDescription:
        'Članski popust vrijedi za najviše jednu ulaznicu po članu i projekciji. Za ovu ste projekciju već iskoristili dopuštenu člansku ulaznicu.',
      becomeMemberButtonText: 'Učlani se',
      usedAllMembershipsButtonText: 'U redu',
      membershipTicketAvailable: 'Članstvo je primijenjeno.',
      membershipTicketUnavailable:
        'Članstvo je aktivno, ali za ovaj događaj nema dostupne članske ulaznice.',
      disableSportMembershipTicket: 'Za članove',
      invitePageLinkDescription:
        'Pružena poveznica omogućuje korisnicima izravan pristup stranici za kupnju ulaznica.',
      invitePageQrCodeDescription:
        'Preuzmite QR kod koji vodi do kupnje ulaznica i postavite ga na svoj plakat.',
      createEmail: 'Kreiraj e-mail',
      finishOrder: 'ZAVRŠI NARUDŽBU',
      wrongTicketQuantity:
        'Željeni broj ulaznica više nije dostupan. Molimo vas da smanjite količinu i pokušate ponovno.',
      categoryTicketRequirement_one:
        'Za svaki paket odaberite po jednu ulaznicu iz svake kategorije. U svakoj kategoriji mora biti jednak broj ulaznica. Najveći dopušteni broj paketa: {{maxPackages}}.',
      categoryTicketRequirement_few:
        'Za svaki paket odaberite po {{count}} ulaznice iz svake kategorije. U svakoj kategoriji mora biti jednak broj ulaznica. Najveći dopušteni broj paketa: {{maxPackages}}.',
      categoryTicketRequirement_other:
        'Za svaki paket odaberite po {{count}} ulaznica iz svake kategorije. U svakoj kategoriji mora biti jednak broj ulaznica. Najveći dopušteni broj paketa: {{maxPackages}}.',
      selectCategoryTicketPackage:
        'Odaberite ulaznice iz svake kategorije kako biste složili barem jedan paket.',
      maxCategoryTicketPackages:
        'Premašili ste dopušteni broj paketa ({{maxPackages}}). Uklonite višak ulaznica za nastavak.',
      missingCategoryPackageTickets_one:
        'Dodajte još jednu ulaznicu u kategoriju u kojoj imate manje odabranih ulaznica.',
      missingCategoryPackageTickets_few:
        'Dodajte još {{count}} ulaznice u kategorije u kojima imate manje odabranih ulaznica.',
      missingCategoryPackageTickets_other:
        'Dodajte još {{count}} ulaznica u kategorije u kojima imate manje odabranih ulaznica.',
      keksPayDesc: 'Najbrže i bez naknada putem KEKS Pay aplikacije!',
      selected: 'Odabrano',
      selectedSeat: 'Odabrano mjesto',
      available: 'Dostupno',
      unavailable: 'Nedostupno',
      unavailableSeat: 'Nedostupno mjesto',
      unselectedSector: 'Neodabrani sektor',
      postalCode: 'Poštanski broj',
      tryAgain: 'Pokušaj ponovno',
      newRequest: 'Novi zahtjev',
      chooseTickets: 'Izaberi ulaznice putem plana dvorane',
      seatSelection: 'Odabir sjedala',
      sendRequest: 'Pošalji zahtjev',
      membershipRequest: 'Zahtjev za članstvo',
      chooseMembershipType: 'Odaberi vrstu članstva',
      membershipRequestDescription: 'Pošalji zahtjev za članstvo.',
      membershipRequestButton: 'Pošalji zahtjev',
      membershipRequestSuccess: 'Zahtjev za članstvo je uspješno poslan',
      membershipRequestError: 'Zahtjev za članstvo nije poslan',
      membershipRequestErrorDescription:
        'Nažalost, dogodila se neka greška. Molimo pokušajte ponovno.',
      membershipRequestErrorButton: 'Pokušaj ponovno',
      membershipRequestStatus: 'Status zahtjeva za članstvo',
      membershipRequestStatusPending: 'Na čekanju',
      membershipRequestStatusApproved: 'Odobren',
      membershipRequestStatusRejected: 'Odbijen',
      contacts: 'Kontakti',
      ticketCategory: 'Kategorije ulaznica',
      ticketCategoryZkm: 'Odaberi mjesta',
      required: 'Ovo polje je obavezno',
      date: 'Ovo polje mora biti datum',
      lastName: 'Prezime',
      between: 'Ovo polje je izvan raspona',
      minLength: 'Ovo polje treba sadržavati više znakova',
      maxLength: 'Ovo polje treba sadržavati manje znakova',
      minDate: 'Ovo polje bi trebalo biti nakon',
      maxDate: 'Ovo polje bi trebalo biti prije',
      personalDataProtection: 'Pravila zaštite osobnih podataka',
      EmailError: 'Molimo obavezno navedite email',
      httpUrl: 'Ovo polje mora biti http ili https url',
      minValue: 'Navedena vrijednost je premala',
      maxValue: 'Navedena vrijednost je prevelika',
      sameAs: 'Ovo polje mora biti isto kao neko drugo polje',
      loginModalDescription: 'Prijavi se pomoću svoje email adrese i lozinke',
      noPasswordQuestion: 'Nemaš lozinku?',
      oneTimePasswordLogin: 'Prijava putem jednokratne lozinke',
      noAccountQuestion: 'Nemaš račun?',
      signUpHere: 'Registriraj se ovdje.',
      loginHere: 'Prijavi se ovdje',
      otpLoginTitle: 'Prijava pomoću jednokratne lozinke',
      otpLoginDescription:
        'Unesite email adresu računa kojim se želite prijaviti. Na tu adresu poslat ćemo jednokratnu lozinku koju ćete koristiti za brzu i sigurnu prijavu.',
      enterEmail: 'Unesi email',
      sendOneTimePassword: 'Pošalji jednokratnu lozinku',
      backToPasswordLogin: 'Povratak na prijavu putem korisničkih podataka',
      notIn: 'Navedena vrijednost je već zauzeta',
      numeric: 'Ovo polje mora biti broj',
      url: 'Ovo polje mora imati važeći url',
      ticketQuantityError:
        'Količina napravljenih karata je manja od broja mjesta s kojima se povezuje! Molimo Vas da povećate količinu odabrane karte ili odaberite manju količinu mjesta.',
      requiredSeatError: 'Molimo, odaberite susjedna mjesta. Nije dozvoljeno ostavljanje praznih.',
      seatMaxLimitReached: 'Dosegnut je maksimalan broj ulaznica za ovu vrstu ulaznice.',
      bundleOfferChooseMore: 'Odaberi još',
      bundleOfferChooseMoreGratisCount: '{{count}} gratis',
      bundleOfferChooseMoreGratis: 'Odaberi još {{count}} gratis.',
      bundleOfferGratisAdded: 'Dobili ste {{count}} gratis ulaznica.',
      bundleOfferFixExcessGratis:
        'Odaberi još {{count}} ulaznica za ponovnu aktivaciju gratis ulaznice ili ukloni gratis sjedalo.',
      companyRegistered:
        'Društvo je upisano u sudski registar Trgovačkog suda u Zagrebu pod brojem 081377997. Temeljni kapital društva iznosi 2.800,00 EUR i uplaćen je u cijelosti. Račun za redovno poslovanje društva vodi se kod Privredne Banke Zagreb',
      organizerMessage: 'Poruka organizatora',
      organizer: 'Organizator',
      ourAddresses: 'Naše adrese',
      totalNoTax: 'Ukupno bez poreza',
      curatedInvitationResponse: 'Vaš odgovor je uspješno spremljen',
      cardPayment: 'Kartično plaćanje',
      paymentMethod: 'Način plaćanja',
      operator: 'Operater / Račun izdao',
      base: 'osnovice',
      eventDate: 'Datum eventa',
      notes: 'Napomene',
      coreEventFee: 'CoreEvent naknada',
      coreEventFeeInvoice: 'CoreEvent naknada za izdavanje ulaznice',
      whatIsCoreEventFee: 'Što je CoreEvent naknada?',
      contractForCustomers: 'Opći uvjeti ugovora za kupce',
      marketingConsent:
        'Dajem svoju privolu da CoreEvent d.o.o. obrađuje moje osobne podatke u gore navedenom obrascu sukladno svrsi i namjeri Organizatora Događaja za koji kupujem Ulaznicu putem Portala te da CoreEvent d.o.o. obrađuje danu email adresu u svoje marketinške svrhe i da svoju privolu u navedenu svrhu mogu svakodobno uskratit, sve sukladno Općoj uredbi o zaštiti podataka te',
      marketingConsentEuropeanGymnastics:
        'Dajem svoju privolu da CoreEvent d.o.o. obrađuje moje osobne podatke u gore navedenom obrascu sukladno svrsi i namjeri Organizatora Događaja za koji kupujem Ulaznicu putem Portala te u ime i za račun organizacije European Gymnastics, kao suorganizatora / nadležnog sportskog tijela, te da CoreEvent d.o.o. obrađuje danu email adresu u svoje marketinške svrhe. Svoju privolu u navedenu svrhu mogu svakodobno uskratiti, sve sukladno Općoj uredbi o zaštiti podataka te Pravilima zaštite osobnih podataka na internet stranicama - COREEVENT.',
      pieces: 'kom',
      coreEventFeeDescription:
        'CoreEvent naknada pokriva troškove brze i sigurne prodaje ulaznica. Naknada, primijenjena na svaku kupljenu ulaznicu, uključuje troškove podrške, održavanja serverskog sustava te administrativnih poslova. Visina naknade može varirati prema komercijalnom dogovoru s Organizatorom događaja i nije povratna.',
      gdprText: 'Pravilima zaštite osobnih podataka na internet stranicama - COREEVENT.',
      itemAmount: 'Iznos stavke',
      customer: 'Kupac',
      tax: 'Porez',
      understand: 'Razumijem',
      price: 'cijena',
      amount: 'Kol.',
      unit: 'jed.',
      ticketUnavailable: 'Ulaznice trenutno nisu dostupne',
      ticketUnavailableDescription:
        'Za informaciju o dostupnosti ulaznica molimo  kontaktirajte organizatora događaja.',
      eventCanceled: 'Događaj je otkazan',
      eventCanceledDescription:
        'Za ulaznice kupljene preko webshopa ostvarit ćete automatski povrat.',
      viewAllEvents: 'Pogledaj sve događaje',
      ticketSoldOut: 'Ulaznice su rasprodane.',
      ticketSoldOutDescription: 'Nažalost, sve ulaznice za ovaj događaj su rasprodane.',
      eventFull: 'Događaj popunjen',
      eventFullDescription:
        'Sva mjesta za ovaj događaj su popunjena. Za eventualnu dodatnu dostupnost, javite se organizatoru.',
      backToEvents: 'Natrag na događaje',
      productDescription: 'Opis proizvoda/usluge',
      inoviceNum: 'R. br.',
      retailCustomer: 'Maloprodajni kupac',
      orderDiscount: 'Promo kod popust:',
      giftCardDiscount: 'Iznos poklon kartice:',
      promoCodeDiscount: 'Promo kod popust:',
      invoiceDate: 'Datum računa',
      invoiceIssued: 'Račun izdao',
      paymentDeadline: 'Rok plaćanja',
      is: 'je',
      backToEventPage: 'Natrag na stranicu događaja',
      backToZkm: 'Natrag na',
      invoiceNumber: 'Račun broj',
      invoicePendingTitle: 'Račun je u pripremi',
      invoicePendingDescription: 'Stranica će se automatski osvježiti kada račun bude spreman.',
      invoiceLoadError: 'Račun nije moguće učitati. Pokušajte ponovno.',
      invoiceRetry: 'Provjeri ponovno',
      viewTheOrder: 'Pogledaj narudžbu',
      yourTicketTo: 'Tvoja ulaznica za',
      getMyTicket: 'Preuzmi moje ulaznice',
      bulledInName:
        'Ova stavka zaračunata je u ime i za račun organizatora događaja (prodavatelja)',
      paymentSuccessful: 'Uspješna kupnja!',
      ticketDescription:
        'Kupnjom ove ulaznice posjetitelj u potpunosti prihvaća sve uvjete i pravila ponašanja mjesta događanja i organizatora te uvjete navedene na ovoj ulaznici. Nepridržavanjem navedenih uvjeta i pravila posjetitelju će biti zabranjen ulazak na događaj odnosno bit će udaljen s mjesta događanja. Nakon kupnje, ulaznicu nije moguće zamijeniti niti vratiti osim u slučaju otkazivanja ili promjene datuma događaja. CoreEvent ne snosi odgovornost u slučaju oštećenja, gubitka ili krađe ulaznice ili njenih zaštitnih podataka (poput barkoda, serijskog broja, zaštitnog koda i sl.) te u tim i sličnim slučajevima povrat novca niti zamjena ulaznice nije moguća. Oštećena, ukradena, krivotvorena te ulaznica bez odreska ili zaštitnih podataka je nevažeća i s takvom ulaznicom posjetitelj neće moći ući na događaj. Ulaznice kupuj isključivo na ovlaštenim prodajnim mjestima! Nakon očitanja jedinstvenog koda na ulaznici, ulaznica postaje nevažeća, a ulaz dopušten samo prvom donosiocu te ulaznice. Svaki sljedeći pokušaj ulaska istim kodom bit će onemogućen. CoreEvent d.o.o. je posrednik u prodaji ulaznica i ne organizira događaje za koje prodaje ulaznice te kao takav ne snosi odgovornost za povrat novca niti izmjene u programu događaja. Ako dođe do otkazivanja događaja ili promjene datuma održavanja, povrat novca će biti moguć isključivo na prodajnom mjestu na kojem je ulaznica kupljena i to u roku od mjesec dana od planiranog početka događaja. U određenim slučajima, povrat novca će biti osiguran direktno od organizatora o čemu će kupci biti na vrijeme obaviješteni. Višeinformacija možeš dobiti na www.core-event.co te na e-mail adresi support@core-event.co. Svako krivotvorenje, zloupotreba i ilegalna preprodaja CoreEvent ulaznica je kažnjiva zakonom i bit će prijavljena policiji. Namjesto događanja zabranjeno je unositi oružje, pirotehnička sredstva, boce, limenke i ostale predmete koji mogu ugroziti sigurnost te opremu za audiovizualno snimanje. Glasn glazba može oštetiti tvoj sluh. Dolaskom na događaj, posjetitelj u potpunosti preuzima sve rizike poput rizika od gubitka, krađe i oštećenja vlastite imovine te rizika od tjelesnih ozljeda. Dolaskom na događaj posjetitelj pristaje biti audiovizualno snimljen bez ograničenja i bez mogućnosti financijske kompenzacije za upotrebu navedenih snimki.',
      ticketReady:
        'Tvoja je ulaznica kupljena i nalazi se u tvojem profilu, a uskoro će biti dostavljena i na tvoju email adresu. Želimo ti ugodan provod!',
      subscriptionReady:
        'Tvoja je pretplata uspješno kupljena i sada je aktivna u tvojem profilu. Uskoro ćeš dobiti potvrdu detalja putem e-maila. Dobrodošao u sezonu!',
      issuedInTheName: 'U ime i za račun organizatora izdao',
      released: 'Izdano',
      isNot: 'nije',
      purchasedIn: 'Ulaznica je kupljena u',
      function: 'Funkcija',
      companyOrganization: 'Ime tvrtke / organizacije',
      vat: 'OIB',
      organizerSeller: 'Organizator (prodavatelj)',
      order: 'Narudžba',
      event: 'Event',
      exchangeRate: 'Preračunato po fiksnom tečaju konverzije 1 EUR = 7,53450 HRK',
      useTerm: 'Uvjeti korištenja',
      ticketAsReceipt:
        ' u sustavu PDV-a prema čl. 90, st. 1 i 2 Zakona o PDV-u. Ulaznica vrijedi kao račun.',
      coreEventTeam: 'Ugodan provod želi ti tvoj CoreEvent tim!',
      yourTicketLocation:
        'Svoju ulaznicu možeš pronaći na dnu ove stranice. Ulaznicu možeš isprintati ili je na svom mobilnom telefonu pokazati na ulazu.',
      loginHeader: 'Hej, dobrodošao nazad!',
      forgotPasswordLogin: 'Zaboravljena lozinka?',
      singedInAs: 'Prijavljen si kao:',
      clickHere: 'Klikni ovdje',
      submitNote: 'Hvala!',
      submitNoteDescription: 'Informacije koje ste dali poslane su organizatorima.',
      address: 'Adresa',
      remainingTime: 'Preostalo vrijeme',
      inTotal: 'Ukupno',
      logIn: 'Prijava',
      buyATicket: 'Kupi ulaznice',
      downloadTickets: 'Preuzmi ulaznice',
      buyATicketZkm: 'Kupi ulaznice',
      continueShopping: 'Nastavi s kupnjom',
      addPromoCode: 'Dodaj promo kod',
      cart: 'Košarica',
      linkLocationWithUserProfileCheckbox: 'Automatski koristi ovu lokaciju za buduće kupovine',
      ticketType: 'Vrste ulaznice',
      subscriptionType: 'Vrsta pretplate',
      ticketTypeRegular: 'Vrsta',
      ticketQuantity: 'Količina',
      cancel: 'Odustani',
      youAreNot: 'Ti nisi',
      customerData: 'Podaci o kupcu',
      ticketPersonalizationCheckoutDescription:
        'Unesite podatke o kupcu. Zatim ispunite polja o posjetiteljima.',
      ticketOwnerDetails: 'Podaci vlasnika ulaznice',
      ticketOwnerDetailsDescription: 'Obvezna su polja označena zvjezdicom.',
      ticketOwnerSameAsBuyer: 'Podaci vlasnika isti su kao podaci kupca',
      ticketOwnerSendTicketToOwner: 'Pošalji ulaznicu i na e-mail vlasnika',
      ticketOwnerFirstNameRequired: 'Ime vlasnika je obvezno.',
      ticketOwnerLastNameRequired: 'Prezime vlasnika je obvezno.',
      ticketOwnerEmailRequired: 'E-mail vlasnika je obvezan.',
      ticketOwnerValidationError: 'Molimo unesite podatke vlasnika za svaku ulaznicu.',
      ticketOwnerTitleWithName: 'Ulaznica {{ticketName}} #{{ticketNumber}}',
      ticketOwnerTitle: 'Ulaznica #{{ticketNumber}}',
      customerDataDescription: 'Obvezna su polja označena zvjezdicom.',
      ownerData: 'Podaci vlasnika',
      confirmOrder: 'Potvrdi narudžbu',
      and: 'i',
      yourAccount: 'Tvoj korisnički račun',
      zkmSignIn: 'Nisi prijavljen(a)',
      regularSignIn: 'Nisi prijavljen(a)',
      loginToContinue: 'Prijavi se kako bi nastavio/la s kupnjom.',
      notLoggedIn: 'Nisi prijavljen(a)',
      loginFormEmail: 'Email*',
      loginFormPassword: 'Lozinka*',
      accountLogin: 'Prijavi se s korisničkim računom',
      conditionsOfSale: 'uvjete prodaje',
      quickRegister: 'Brzo i jednostavno izradi račun.',
      quickRegisterDescription:
        'Izradi lozinku za svoj novi CoreEvent račun i uživaj u pogodnostima brže kupnje ulaznica i jednostavnog pristupa svim kupljenim ulaznicama. Za izradu računa koristit ćemo gore navedenu email adresu.',
      subscription1: 'Slažem se da se moja adresa e-pošte podijeli s organizatorom ',
      subscription2:
        ' u svrhu primanja obavijesti o najnovijim događajima, ponudama ili bilo kojim važnim informacijama vezanih uz događaje spomenutog organizatora.',
      termsOfUse: 'uvjete korištenja',
      emailLogin: 'Prijava e-mailom',
      registerIfNoAccount: 'Nemaš račun? Registriraj se ',
      here: 'ovdje',
      register: 'Registriraj se',
      signInToContinue: 'Prijavi se kako bi nastavio s kupovinom',
      remainingSeats: 'Broj preostalih mjesta:',
      googleLogin: 'Google prijava',
      facebookLogin: 'Facebook prijava',
      acceptCoreEvent: 'Prihvaćam CoreEvent',
      guest: 'Nastavi kao gost',
      guestZkm: 'Podaci o kupcu',
      loginDescription:
        'Prijavi se sa svojim korisničkim računom i na jednom mjestu čuvaj ulaznice za sve događaje ili samo nastavi kao gost. Možeš izraditi račun niže.',
      forgotPasswordPageHeader: 'Zaboravljena lozinka',
      cryptoPayment: 'Plaćanje kriptovalutama',
      giftCardPayment: 'Poklon kartica',
      giftCardPaymentDescription: 'Plaćanje poklon karticom',
      kiPayment: 'Kulturna iskaznica',
      kiPaymentDescription: 'Plaćanje Kulturnom iskaznicom',
      kiPartialPaymentTitle: 'Djelomično plaćanje Kulturnom iskaznicom',
      kiPartialPaymentDescription:
        'Kulturna iskaznica odobrila je djelomičan iznos. Preostali iznos bit će naplaćen karticom.',
      kiTotalOrderAmount: 'Ukupni iznos narudžbe',
      kiApprovedAmount: 'Odobreno Kulturnom iskaznicom',
      kiCardPaymentAmount: 'Za plaćanje karticom',
      kiContinueToCardPayment: 'Nastavi na plaćanje karticom',
      kiCancelPurchase: 'Odustani od kupnje',
      kiPaymentDetailsError: 'Nije moguće dohvatiti podatke o plaćanju.',
      kiCancelPaymentError: 'Poništenje transakcije nije uspjelo. Pokušajte ponovno.',
      giftCardDataTitle: 'Podaci poklon kartice',
      giftCardCode: 'Kod poklon kartice*',
      giftCardAmount: 'Iznos (EUR)*',
      giftCardDescription:
        'Unesi broj kartice i iznos kojeg želiš potrošiti u ovoj narudžbi. U idućem koraku ćeš dovršiti plaćanje ako si odabrao još neki od ostalih oblika.',
      giftCardAvailability: 'dostupno',
      finishPaymentInNextStep: 'Plaćanje ćeš završiti na sljedećem koraku',
      onlinePaymentWspay: 'Online plaćanje putem WS Pay sustava',
      onlinePaymentProvider: 'Online plaćanje putem {{provider}} sustava',
      paymentMethodsLoading: 'Učitavanje načina plaćanja…',
      paymentMethodsUnavailable: 'Trenutno nema dostupnih načina plaćanja.',
      paymentMethodsError: 'Nije moguće učitati načine plaćanja. Osvježi stranicu i pokušaj ponovno.',
      paymentCheckoutError: 'Nije moguće pokrenuti plaćanje. Pokušaj ponovno.',
      onlinePaymentCorvus: 'Online plaćanje putem Corvus Pay sustava',
      changePassword: 'Promjeni lozinku',
      choosePaymentMethod: 'Odaberi način plaćanja',
      revolutPaymentTitle: 'Plati karticom, Revolut Payom i drugim načinima',
      revolutPaymentDescription: 'Sigurno plaćanje putem Revoluta',
      newPassword: 'Nova lozinka',
      repeatPassword: 'Ponovi lozinku',
      confirmPassword: 'Potvrdi lozinku',
      passwordLengthErrorMessage: 'Lozinka mora imati najmanje 5 znakova',
      passwordsDoNotMatchError: 'Lozinke se ne podudaraju',

      registration: 'Registracija',
      registerPaymentVerification: 'Provjera kupnje i plaćanja',
      registrationFinish: 'Zahvaljujemo se na registraciji!',
      registrationDescription:
        'Podaci koje ste naveli poslani su organizatorima. Poslat ćemo Vam e-mail u što kraćem roku.',
      addAttendee: 'Dodaj još jednog posjetitelja',
      aplicationsClosed: 'Prijave su zatvorene',
      aplicationSuccessful: 'Uspješno ste registrirali osobu.',
      tsLoginPrompt: 'Prijavi se u sustav kako bi nastavio/la s kupnjom',
      tsLoginEmail: 'Prijavi se emailom',
      tsRegister: 'Registriraj se',
      tsSelectSubscriptionStep: '1. Odaberi pretplatu',
      tsSelectSeatStep: '2. Odaberi sjedalo',
      tsSeatInCart: 'U košarici',
      tsSubscribers: 'Pretplatnici',
      tsEditSubscriber: 'Uredi',
      tsSeatNotSelected: 'Sjedalo nije odabrano',
      tsChangeSeat: 'Promijeni',
      tsRow: 'Red',
      tsSeat: 'Sjedalo',

      tsSubscriber: 'Pretplatnik',
      tsFirstName: 'Ime',
      tsLastName: 'Prezime',
      tsEmail: 'E-mail',
      tsPhone: 'Telefon',
      tsAddSubscriber: 'Dodaj pretplatnika',
      tsRemoveSubscriber: 'Ukloni',
      tsChooseSubscriberSeat: 'Odaberi sjedalo',
      tsOrderAlreadyReserved: 'Narudžba je već rezervirana. Ponovite pripremu plaćanja kako biste zadržali rezervirana sjedala.',

      tsPriceLabel: 'Cijena:',
      tsValidFromTo: 'Vrijedi od {{from}} do {{to}}',
      tsAlreadyOwned: 'Već kupljeno',
      tsSoldOut: 'Rasprodano',
      tsAdmissionSeated: 'Numerirano',
      tsAdmissionGeneral: 'Nenumerirano',
      tsLoadingFloorPlan: 'Učitavanje tlocrta...',
      tsPurchaseTitle: 'Kupnja kazališne pretplate',
      tsKinoHrPurchaseTitle: 'Kupnja filmske pretplate',
      tsSubscriptionLabel: 'Kazališna pretplata',
      tsErrorLoadSubscriptions: 'Neuspješno učitavanje pretplata.',
      tsErrorLoadFloorPlan: 'Neuspješno učitavanje tlocrta za ovu pretplatu.',
      tsErrorLoginRequired: 'Molimo prijavite se za nastavak.',
      tsErrorReservationFailed:
        'Rezervacija nije uspjela — provjerite imate li već aktivnu pretplatu ili je li sjedalo dostupno.',
      tsErrorReserveGeneric: 'Došlo je do pogreške pri rezervaciji pretplate.',
      tsErrorInvalidEmail: 'Molimo unesite ispravnu email adresu prije nastavka.',
      tsErrorNameRequired: 'Molimo unesite ime i prezime.',
      tsErrorSeatRequired: 'Molimo odaberite barem jedno sjedalo prije nastavka.',
      tsErrorPurchaseGeneric: 'Došlo je do pogreške tijekom kupnje.',
      tsGoogleLoginNotSuccessful: 'Google prijava nije uspjela. Molimo pokušajte ponovno.',
      tsGoogleLoginFailed: 'Google prijava nije uspjela. Molimo pokušajte ponovno.',
      tsOpisLabel: 'Opis',
      tsCartTitle: 'Košarica',
      tsCartEmpty: 'Nije odabrana pretplata',
      tsCartEmptyHint: 'Odaberite pretplatu s liste za nastavak',
      tsCartValidLabel: 'Vrijedi:',
      tsCartVenueLabel: 'Dvorana:',
      tsCartPromoLabel: 'Unesite promo kod (opcionalno)',
      tsCartPriceLabel: 'Cijena pretplate:',
      tsCartSeatLabel: 'Sjedalo:',
      tsCartTotalLabel: 'Ukupno:',
      tsCartContinue: 'Nastavi na naplatu',
      tsCartLoginRequired: 'Molimo prijavite se za nastavak',
      tsCartComplete: 'Dovrši kupnju',
      tsCartNoteLabel: 'Napomena:',
      tsCartNoteLine1: 'Ova pretplata uključuje pristup svim događanjima u razdoblju valjanosti.',
      tsCartNoteLine2: 'Primit ćete QR kod koji omogućuje pristup svim izvedbama.',
      tsFloorPlanUnavailable: 'Tlocrt nije dostupan za ovu pretplatu.',
      tsSelectSeatTitle: 'Odaberite sjedalo',
      tsSeatAvailable: 'Slobodno',
      tsSeatSold: 'Prodano',
      tsSeatSelected: 'Odabrano',

      hostedBy: 'Organizira ',
      at: ' u ',

      attendeeDataDescription:
        'Ovdje možete pružiti informacije koje će se koristiti za izradu vaše akreditacije na događaju.',
      continueToWorkshops: 'Nastavi na radionice',
      send: 'Pošalji',
      back: 'Natrag',

      editSuccess: 'Registracija Vaših podatka je bila uspješna.',
      accountSettings: 'Postavke profila',
      firstName: 'Ime',
      email: 'Email',
      confirmEmail: 'Potvrdi email',
      password: 'Lozinka',
      save: 'Spremi',
      continue: 'Nastavi',
      signupHeader: 'Registriraj se',

      paymentUnsuccessful: 'Kupnja neuspješna!',
      paymentUnsuccessfulDescription:
        'Dogodila se pogreška prilikom kupnje. Molimo da pokušaš ponovno ili odabereš drugi način plaćanja.',
      paymentUnsuccessfulActionButton: 'Natrag na kupnju',
      error: 'Greška',

      paymentDone: 'Uplata je već izvršena',
      paymentCanceled:
        'Uplata je otkazana, bit ćete preusmjereni natrag na obrazac za registraciju',

      termsOfService: 'Uvjeti pružanja usluge',
      termsOfSale: 'Uvjeti prodaje',
      privacyPolicy: 'Politika privatnosti',

      requiredErrorMessage: 'Ovo polje je potrebno',

      '404': 'Stranica nije pronađena',
      editShoppingCart: 'uredi',
      continueShoppingCart: 'Nastavi s kupnjom',
      confirmShoppingCart: 'Potvrdi',
      insertPromoCode: 'Unesite promo kod (neobavezno)',
      cinehillPackageOneTicketRemaining:
        'Ovim promo kodom možete preuzeti još najviše jednu ulaznicu.',
      cinehillPackageTicketsRemaining:
        'Ovim promo kodom možete preuzeti još najviše {{count}} ulaznica.',
      cinehillPackageNoTicketsRemaining: 'Sve ulaznice s ovog promo koda već su preuzete.',
      subtotalPriceLabel: 'Međuzbroj:',

      receiptInfo: 'Podaci za račun',
      privateReceipt: 'Privatni račun',
      r1Invoice: 'Račun na ime tvrtke (R1)',
      legalEntityName: 'Naziv pravne osobe*',
      legalEntityVatNumber: 'OIB*',
      legalEntityVatNumberFormatInvalid:
        'Unesite broj kao neprekinuti niz znakova, npr. 123456789 (bez razmaka, točaka i crtica).',
      legalEntityVatNumberInvalid: 'Unesite važeći broj za odabranu državu, bez oznake države.',
      addressLabel: 'Adresa (ulica i kućni broj)*',
      zipCode: 'Poštanski broj*',
      city: 'Grad*',
      cityOptional: 'Grad',
      country: 'Država*',
      countryOptional: 'Država',
      chooseMinimum: 'Odaberi minimalno',
      tickets1: 'ulaznica',
      tickets2: 'ulaznice',
      promoCodeDescriptionTitle: 'Što je promo kod?',
      promoCodeDescriptionPart1:
        'Prodavatelji mogu dati kupcima promo kod koji se unosi prilikom plaćanja kako bi ostvarili popust za svoju kupnju. Unos promo koda nije obavezan.',
      promoCodeDescriptionPart2: 'Ovdje se može unijeti:',
      promoCodeDescriptionPart3: 'Promo kod za popust pri kupnji',
      promoCodeDescriptionPart4: 'Broj članske kartice ili preplatnički broj za kazališta',
      activate: 'aktiviraj',
      requiredFieldsDescription: 'Obvezna su polja označena zvjezdicom.',
      annualTicket: 'Godišnja ulaznica',
      membership: 'Članstvo',
      eventPasswordRequired: 'Potrebna lozinka',
      eventPasswordSaleUnavailableTitle: 'Ulaznice još nisu u prodaji',
      eventPasswordSaleUnavailableDescription:
        'Prodaja ulaznice putem lozinke trenutno nije dostupna. Molimo vas da pratite obavijesti organizatora o početku otvaranja prodaje.',
      eventPasswordDescription:
        'Pretprodaja je trenutno moguća putem passworda. Ulaznice će uskoro biti dostupne u slobodnoj prodaji.',
      passwordLabel: 'Lozinka',
      backToEvent: 'Natrag na događaj',
      openInExternalBrowser: 'Za prijavu putem Googlea ',
      openInExternalBrowserBold: 'dopustite otvaranje ovog linka u vašem zadanom pregledniku.',
      openInBrowser: 'Otvori u pregledniku',
      loginWithEmail: 'Za prijavu putem maila',
      continueHere: 'Nastavi ovdje',
      checkOnTicketSwap: 'provjeri dostupnost na TicketSwapu',
      checkOnTicketSwapShort: 'provjeri na TicketSwapu',
      bannerText:
        'Dragi kupci, zbog tehničkih poteškoća u WSPay sustavu, plaćanja putem CoreEvent stranice privremeno ne rade. Naš partner radi na brzom otklanjanju problema i uskoro bi plaćanja trebala biti ponovno dostupna. Hvala vam na razumijevanju!',
      ticketsReserved: 'Ulanice su uspješno rezervirane!',
      ticketsReservedDescription: {
        part1: 'Vaše su ulaznice rezervirane, a nakon obrade transakcije',
        part2: 'ulaznice i račun bit će poslani na vaš e-mail',
        part2Free: 'ulaznice će biti poslane na vaš e-mail',
        part3:
          'Moguće je da banka odbije transakciju, o čemu ćete biti obaviješteni e-mailom. Ako je potražnja velika, obrada može potrajati dulje. Hvala na strpljenju!',
        part3Free: 'Ako je potražnja velika, obrada može potrajati dulje. Hvala na strpljenju!',
      },
      ticketsFailedPayment: 'Neuspješna kupnja ulaznica',
      ticketsFailedPaymentDescription: {
        part1:
          'Nažalost, vaša transakcija nije uspješno obrađena te je banka odbila naplatu. Zbog toga',
        part2: ' ulaznice više nisu rezervirane.',
        part3: ' Molimo vas da ponovno odaberete željene ulaznice i dovršite kupnju novom uplatom.',
      },
      repeatPurchase: 'Ponovni kupnju',
      subscriptionCheckoutInterrupted: 'Izašli ste iz plaćanja',
      subscriptionCheckoutInterruptedDescription: 'Plaćanje nije potvrđeno i pretplata nije aktivna. Provjeravamo konačni status transakcije.',
      subscriptionPaymentChecking: 'Provjeravamo plaćanje',
      subscriptionPaymentCheckingDescription: 'Pretplata će postati aktivna nakon potvrde plaćanja.',
      subscriptionPaymentPendingAdvice: 'Mjesta ostaju privremeno rezervirana dok plaćanje nije potvrđeno. Prije ponovne kupnje provjerite ovu narudžbu. Potvrdu i račun šaljemo tek nakon uspješne kupnje.',
      subscriptionPaymentUnconfirmed: 'Plaćanje još nije potvrđeno',
      subscriptionPaymentCheckingStatus: 'Provjeravamo status plaćanja.',
      subscriptionPaymentCanceled: 'Plaćanje je otkazano',
      subscriptionPaymentNotCompleted: 'Plaćanje nije dovršeno',
      subscriptionPaymentNotCompletedDescription: 'Ovim plaćanjem nije dovršena kupnja pretplate. Možete se vratiti na popis pretplata.',
      subscriptionReserved: 'Pretplata je uspješno rezervirana!',
      subscriptionReservedDescription: {
        part1: 'Vaša pretplata je rezervirana, a nakon obrade transakcije',
        part2: 'potvrda pretplate i račun bit će poslani na vaš e-mail',
        part2Free: 'potvrda pretplate bit će poslana na vaš e-mail',
        part3:
          'Moguće je da banka odbije transakciju, o čemu ćete biti obaviješteni e-mailom. Ako je potražnja velika, obrada može potrajati dulje. Hvala na strpljenju!',
        part3Free: 'Ako je potražnja velika, obrada može potrajati dulje. Hvala na strpljenju!',
      },
      subscriptionFailedPayment: 'Neuspješna kupnja pretplate',
      subscriptionFailedPaymentDescription: {
        part1:
          'Nažalost, vaša transakcija nije uspješno obrađena te je banka odbila naplatu. Zbog toga',
        part2: ' vaša pretplata više nije rezervirana.',
        part3: ' Molimo vas pokušajte ponovno dovršiti kupnju novom uplatom.',
      },
      repeatSubscriptionPurchase: 'Pokušaj ponovno kupiti pretplatu',
      ticketsSuccessfulPayment: 'Uspješna kupnja ulaznica',
      ticketsSuccessfulPaymentDescription: {
        part1: 'Vaša je kupnja uspješno dovršena!',
        part2: ' Ulaznice i račun će biti poslani u najkraćem mogućem roku na vašu e-mail adresu.',
        part2Free: ' Ulaznice će biti poslane u najkraćem mogućem roku na vašu e-mail adresu.',
        part3: 'Hvala vam na povjerenju i želimo vam ugodno iskustvo na događaju!',
      },
      transactionStatuses: {
        PENDING: 'Transakcija u obradi',
        SUCCESSFUL: 'Transakcija uspješna',
        FAILED: 'Transakcija nije uspjela',
      },
      transactionStatusesDescription: {
        PENDING: 'Molimo pričekajte.',
        SUCCESSFUL: '',
        FAILED: 'Pokušajte ponovno.',
      },
      protectTicketPurchase: 'Zaštiti svoju kupnju ulaznice',
      addTicketInsuranceRecommended: 'Dodaj osiguranje ulaznica (preporučeno)',
      noTicketInsurance: 'Ne želim osiguranje ulaznica',
      noSurcharge: 'Bez nadoplate',
      insuranceTerms: 'Uvjetima osiguranja',
      ticketInsuranceDescriptionPart1: 'Dodavanjem zaštite ulaznica ostvaruješ pravo na ',
      ticketInsuranceDescriptionHighlighted: 'povrat iznosa kupnje',
      ticketInsuranceDescriptionPart2:
        ' ako zbog opravdanih i dokumentiranih razloga ne možeš prisustvovati događaju. Pokriveni razlozi i uvjeti povrata detaljno su navedeni u ',
      ticketInsuranceDescriptionPart3:
        '. Cijena zaštite dodaje se ukupnom iznosu narudžbe, a potvrdu osiguranja primit ćeš e-mailom nakon kupnje.',
      insuranceReasonHealth: 'Zdravstveni razlozi',
      insuranceReasonHealthSub: '(uključujući bolest djeteta)',
      insuranceReasonAccidents: 'Nezgode i ozljede',
      insuranceReasonTraffic: 'Prometne nezgode',
      insuranceReasonPublicTransport: 'Kašnjenja javnog prijevoza',
      insuranceReasonEmergency: 'Izvanredne situacije',
      insuranceReasonEmergencySub: '(npr. požar, poplava ili provala)',
      insuranceReasonOther: 'Ostali hitni slučajevi',
      insuranceReasonOtherSub: '(u skladu s uvjetima osiguranja)',
      insuranceConfirmationPart1: 'Potvrđujem da sam upoznat s ',
      insuranceConfirmationPart2: ' i da ih prihvaćam.',
      insuranceSelectionRequired: 'Potrebno je odabrati jednu od opcija.',
      insuranceTermsRequired: 'Potrebno je prihvatiti uvjete osiguranja.',
      ticketInsurance: 'Osiguranje ulaznica',
      ticketTypes: 'Vrste ulaznica',
      selectLocation: 'Odaberi mjesto',
      chooseTicketCategory: 'Odaberi kategoriju ulaznice',
      chooseFloorPlanTicket: 'Odaberi ulaznicu',
      allFloorPlanTicketTypes: 'Sve vrste ulaznica',
      floorPlanZoomIn: 'Povećaj tlocrt',
      floorPlanZoomOut: 'Smanji tlocrt',
      floorPlanResetView: 'Vrati početni prikaz',
      readMore: 'ČITAJ VIŠE',
      readLess: 'ČITAJ MANJE',
      details: 'Detalji',
      section: 'Sektor',
      row: 'Red',
      seat: 'Sjedalo',
      tableNumber: 'Broj stola',
      capacity: 'Kapacitet',
      floorPlanHelperRange: 'Odaberi {{min}}-{{max}} ulaznica',
      floorPlanHelperMaxOnly: 'Maks. {{max}} ulaznica',
      sharedTableChoosePackage: 'Odaberite jedan od dostupnih paketa za stol.',
      sharedTableNoAvailablePackages: 'Trenutno nema dostupnih paketa za stol.',
      sharedTableTicketSingular: 'ulaznica',
      sharedTableTicketPlural: 'ulaznice',
      add: 'Dodaj',
      close: 'Zatvori',
      addedToCart: 'Dodano u košaricu',
      accessibleTicketInfo:
        'Ako vam je potrebna dodatna prilagodba ili veća fleksibilnost, slobodno nas kontaktirajte organizatora izravno putem telefona ili e-maila radi rezervacije.',
      escortQuestion: 'Hoćete li imati pratnju (osobu koja vas prati)?',
      escortYes: 'Da',
      escortNo: 'Ne',
      disabilityCardNumber: 'Broj invalidske iskaznice',
      disabilityCardNumberRequired:
        'Molimo unesite broj invalidske iskaznice za svaku pristupačnu ulaznicu.',
      insuranceWithdrawal: {
        pageTitle: 'Odustajanje od osiguranja ulaznice',
        explanation:
          'Imate pravo odustati od osiguranja ulaznice u roku od 14 dana od zaključenja ugovora o osiguranju, odnosno od primitka potvrde o osiguranju, bez navođenja razloga. Odustajanje od osiguranja ne utječe na vašu ulaznicu, koja ostaje vrijediti.',
        loading: 'Učitavanje podataka o narudžbi…',
        eventLabel: 'Događaj',
        purchaseDateLabel: 'Datum kupnje',
        insuredAmountLabel: 'Osigurani iznos',
        invoiceNumberLabel: 'Broj računa',
        invoiceNumberHint: 'Broj računa kao na računu, npr. 118494-1-12',
        invoiceNumberRequired: 'Unesite broj računa.',
        emailLabel: 'E-mail',
        emailRequired: 'Unesite e-mail korišten prilikom kupnje.',
        emailInvalid: 'Unesite valjanu e-mail adresu.',
        messageLabel: 'Poruka (nije obavezno)',
        confirmationLabel: 'Potvrđujem da želim odustati od osiguranja ulaznice za ovu narudžbu.',
        confirmationRequired: 'Molimo potvrdite odustajanje za nastavak.',
        submit: 'Potvrdi odustajanje',
        submitting: 'Slanje…',
        alreadyReceivedTitle: 'Odustajanje je već zaprimljeno',
        alreadyReceivedDescription: 'Obavijest o odustajanju za ovu narudžbu već smo zaprimili {{receivedAt}}.',
        successTitle: 'Obavijest o odustajanju zaprimljena',
        successDescription:
          'Vašu obavijest o odustajanju zaprimili smo {{receivedAt}}. Vaša referenca je {{reference}}. Ulaznica ostaje vrijediti.',
        notFoundTitle: 'Narudžba nije pronađena',
        notFoundDescription:
          'Nismo pronašli narudžbu koja odgovara unesenim podacima, ili ta narudžba nema osiguranje ulaznice. Provjerite broj računa i e-mail te pokušajte ponovno.',
        throttledTitle: 'Previše pokušaja',
        throttledDescription: 'Pričekajte malo pa pokušajte ponovno.',
        networkErrorTitle: 'Dogodila se pogreška',
        networkErrorDescription: 'Nismo se mogli spojiti na server. Provjerite vezu i pokušajte ponovno.',
        tryAgain: 'Pokušaj ponovno',
      },
    },
  },
}
